var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_core.js
// module id = 43
// module chunks = 168707334958949